// Vue.component('example-component', require('./components/ExampleComponent.vue'));

//We need a main bus for vendor selection
import Vue from 'vue/dist/vue.js';
import CustomSelectComponent from './components/general_components/CustomSelectComponent.vue';
import VenueSelectionComponent from './components/header_nav/VenueSelectionComponent.vue';
import DashboardPage from './components/dashboard/DashboardPage.vue';
import AuditsShowPage from './components/dashboard/AuditsShowPage.vue';
import StatsNumberCardComponent from './components/dashboard/graphs/StatsNumberCardComponent.vue';
import UsersPage from './components/users_page/UsersPage.vue';
export const venue_selection_bus = new Vue();

Vue.component(
	'custom_select',
	CustomSelectComponent
);

Vue.component(
	'venue_select',
	VenueSelectionComponent
);

Vue.component(
	'dashboard_page',
	DashboardPage
);

Vue.component(
	'audits-show-page',
	AuditsShowPage
);

Vue.component(
	'stats-card',
	StatsNumberCardComponent
);

Vue.component(
	'users-page',
	UsersPage
);
